import { render, staticRenderFns } from "./SalesResult.html?vue&type=template&id=13bfd2ae&external"
import script from "./SalesResult.ts?vue&type=script&lang=ts&external"
export * from "./SalesResult.ts?vue&type=script&lang=ts&external"
import style0 from "./SalesResult.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports